export default function OverlayLayerRenderer({ layer }) {
  const data = layer.data;
  return (
    <div style={{
      width: '100%', height: '100%',
      background: data.fill,
      mixBlendMode: data.blendMode || 'normal',
      pointerEvents: 'none',
    }} />
  );
}
